import React from 'react';
import './SectionTitle.css';

const SectionTitle = ({ subtitle, title, align = 'center' }) => {
        return ( <
                div className = { `section-title section-title-${align}` } > {
                    subtitle && < span className = "section-subtitle" > { subtitle } < /span>} {
                        title && < h2 className = "section-heading" > { title } < /h2>} <
                            /div>
                    );
                };

                export default SectionTitle;